import { Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { expandTheme } from 'utils/theme-util';
import { ModalUtil } from 'services/utils/modal.util';
import { combineStyles } from 'services/utils/styles-service';
import { BaseTableStyles } from '../../../base-table/base-table.styles';

export const NewTableStyles = (theme: Theme) => {
  const { font, palette } = expandTheme(theme);

  return createStyles({
    confirmationModal: {
      ...ModalUtil.BasicModalStyling(theme, 50, 3),
      maxHeight: '60vh',
    },
    confirmationModalHeader: {
      fontWeight: 'bold',
      fontSize: font.mediumFontSize,
    },
    confirmationModalSubHeading: {
      fontSize: font.smallFontSize,
    },
    modalDrugRow: {
      paddingBottom: theme.spacing(1),
    },
    modalCheckbox: {
      paddingLeft: 0,
    },
    submittingIndicator: {
      marginLeft: 10,
      color: palette.primary.white,
    },
    textFieldEndAdornment: {
      cursor: 'pointer',
    },
  });
};

const styles = combineStyles(BaseTableStyles, NewTableStyles);

export const UseStyles = makeStyles(theme => styles(theme));
export { styles };
